import React from "react";
import { AuthProvider } from "../AuthContext";
import Header from "../componentes/layouts/Headers";
import Footer from "../componentes/layouts/Footer.js";
import RutasProductos from "./RutasProductos";

const AppProductos = () => {
    return (
        <AuthProvider>
            <Header/>
            <div style={{ paddingTop: "6rem" }} className="container-fluid">
                <RutasProductos />
            </div>
            <Footer/>
        </AuthProvider>
    );
};

export default AppProductos;